import { useEffect, useRef } from 'react';

export const useInterval = (callback: () => void, delay: number) => {
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        const intervalId = window.setInterval(() => {
            callbackRef.current();
        }, delay);

        return () => {
            window.clearInterval(intervalId);
        };
    }, [delay]);
};
